import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableBonusReportView extends JetView {
    // Defining a new class extending JetView
    config() {
        // Method to define the UI configuration
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Retrieving partner ID from parameters

        // Extending the summTreeColumn filter for custom summation behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    // Refresh method for the custom filter
                    var result = 0; // Variable to hold the summation result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        // Iterating through master data
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result); // Integer format
                    } else {
                        resultFormat = webix.i18n.priceFormat(result); // Price format
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );

        return {
            // Returning the UI configuration
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Defining a tree table view
                            id: 'treetable', // ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                $group: {
                                    // Grouping configuration
                                    by: 'ClientCurrency', // Grouping by client currency
                                    map: {
                                        // Mapping fields for aggregation
                                        Amount: ['Amount', 'sum'],
                                        RolloverRequired: ['RolloverRequired', 'sum'],
                                        AmountConverted: ['AmountConverted', 'sum'],
                                        RolloverWagered: ['RolloverWagered', 'sum'],
                                        RolloverRemaining: ['RolloverRemaining', 'sum'],
                                    },
                                },
                            },
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
                            columns: [
                                // Defining columns for the tree table
                                {
                                    id: 'CreatedLocal', // Column ID
                                    header: _('Fecha Modificación'), // Column header with localization
                                    width: 150, // Column width
                                    template: function (obj, common) {
                                        // Template function for rendering
                                        if (obj.$group)
                                            // Check if the object is a group
                                            return (
                                                common.treetable(obj, common) + // Render group row
                                                obj.value
                                            );
                                        return obj.CreatedLocal; // Return the created date for non-group rows
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID for details
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip for details
                                    template: function (obj) {
                                        // Template function for details icon
                                        if (obj.$level == 1) {
                                            return ''; // No icon for level 1
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon for other levels
                                        }
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 60, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 60, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PartnerBonusId', // Column ID
                                    header: _('Id Bono'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PartnerBonusName', // Column ID
                                    header: _('Nombre de Bono'), // Column header with localization
                                    width: 500, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AcceptanceDateLocal', // Column ID
                                    header: _('Fecha Aceptación'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BonusType', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'CreatedLocal', // Column ID
                                    header: _('Fecha Modificación'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AmountConverted', // Column ID
                                    header: _('Monto Convertido'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'RolloverRequired', // Column ID
                                    header: _('Rollover Requerido'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'RolloverWagered', // Column ID
                                    header: _('Apostado'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'RolloverRemaining', // Column ID
                                    header: _('Restante'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'ClientBonusExpirationDateLocal', // Column ID
                                    header: _('Fecha Expiración'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for clicking on details icon
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    $$('dColl').expand(); // Expand details container
                                    $$('formDetails').clear(); // Clear details form
                                    $$('a5').scrollTo(
                                        // Scroll to the details form
                                        0,
                                        $$('formDetails').$height + $$('treetable').$height / 2 + 55,
                                    );
                                },
                            },
                            ready: function () {
                                // Event handler when the tree table is ready
                                this.openAll(); // Open all rows
                            },
                            autowidth: false, // Disable auto width
                            tooltip: true, // Enable tooltips
                            footer: false, // Disable footer
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }
    init(grid) {
        // Method to initialize the view
        const id_partner = this.getParam('partner', true); // Retrieve partner ID
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('treetable'); // Reference to the tree table
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReport?Partner=' + id_partner + '&'; // Base URL for API requests
        var objectVal = grid.data.pull; // Reference to the data pull
        var filter = ''; // Variable to hold filter string

        // Event listener for bonus report filtering
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add date to filter
                                string1 = string1 + '&dateTo=' + date; // Add date to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format start date
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format end date
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dColl').collapse(); // Collapse details container
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                // Load sorted data
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir,
            );
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                // Load data for selected player
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id,
            );
        });

        // Popup configuration for adding bonus balance
        var popupAdd = webix.ui({
            view: 'window', // Window view
            id: 'AddBonusBalance', // ID for the popup
            width: 450, // Popup width
            height: 450, // Popup height
            head: {
                // Header configuration
                view: 'toolbar', // Toolbar view
                cols: [
                    {
                        view: 'label', // Label for the header
                        label: _('Añadir bono a saldo'), // Localized label
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the popup
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal window
            body: {
                // Body configuration
                view: 'form', // Form view
                id: 'addform', // ID for the form
                elements: [
                    // Form elements
                    {
                        view: 'text', // Text input for User ID
                        label: _('Usuario Id'), // Localized label
                        name: 'UserId', // Input name
                        type: 'number', // Input type
                        labelWidth: 150, // Label width
                        required: true, // Required field
                    },
                    {
                        view: 'combo', // Combo box for bonus type
                        label: _('Tipo'), // Localized label
                        name: 'Type', // Input name
                        required: true, // Required field
                        options: [
                            // Options for the combo box
                            { id: '0', value: _('Premio Torneo Casino') },
                            { id: '1', value: _('Premio Torneo Deportivas') },
                            { id: '2', value: _('Premio Torneo Virtuales') },
                            {
                                id: '3',
                                value: _('Premio Torneo Casino en Vivo'),
                            },
                            { id: '4', value: _('Sorteos') },
                            { id: '5', value: _('Sorteos Casino') },
                            { id: '6', value: _('Sorteos Virtuales') },
                            { id: '7', value: _('Sorteos Casino en Vivo') },
                        ],
                        labelWidth: 150, // Label width
                    },
                    {
                        view: 'combo', // Combo box for balance type
                        label: _('Tipo Saldo:'), // Localized label
                        name: 'TypeBalance', // Input name
                        required: true, // Required field
                        options: [
                            // Options for the combo box
                            { id: '0', value: _('Saldo recargas') },
                            { id: '1', value: _('Saldo premios') },
                        ],
                        labelWidth: 150, // Label width
                    },
                    {
                        view: 'text', // Text input for reference
                        label: _('Referencia'), // Localized label
                        name: 'Reference', // Input name
                        labelWidth: 150, // Label width
                        required: false, // Not required
                    },
                    {
                        view: 'text', // Text input for value
                        label: _('Valor'), // Localized label
                        name: 'Value', // Input name
                        type: 'number', // Input type
                        labelWidth: 150, // Label width
                        required: true, // Required field
                    },
                    {
                        cols: [
                            // Button configuration
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    // Click event to cancel
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('addform').setValues(
                                        // Reset form values
                                        $$('addform').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    // Click event to save
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix // AJAX request to save bonus balance
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Bonus/AddBonusBalance', // API endpoint
                                                '{"UserId":"' +
                                                    values.UserId +
                                                    '", "Type":"' +
                                                    values.Type +
                                                    '", "TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '", "Reference":"' +
                                                    values.Reference +
                                                    '", "Value":"' +
                                                    values.Value +
                                                    '", "Partner":"' +
                                                    id_partner +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            // Show error message
                                                            'Error! ',
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            // Check for errors
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error', // Error message type
                                                                text: json.AlertMessage, // Error message text
                                                            });
                                                        } else {
                                                            webix.message(
                                                                // Success message
                                                                _('Bono a saldo añadido correctamente'),
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                // Reload grid data
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            // Reset form values
                                            $$('addform').getCleanValues(),
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    } else {
                                        webix.message({
                                            // Show validation error message
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Message text
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    // Configuration for form elements
                    on: {
                        onChange: function () {
                            // Change event for validation
                            this.validate(); // Validate the form
                        },
                    },
                },
            },
        });
        this.on(this.app, 'addBonusBalance:button', (filter) => {
            // Event listener for showing the add bonus balance popup
            popupAdd.show(); // Show the popup
            $$('addform').clearValidation(); // Clear validation messages
        });
    }
}

// FILE DOCUMENTED
